import PageLabelBar from "../../components/common/PageLabelBar/PageLabelBar";

export default function Team() {
    return (
        <div className="content">
            <PageLabelBar title="Il tuo Team" />
        </div>
    );
}